export default __webpack_public_path__ + "static/media/49_1_4.1b9dd500.png";